import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { logoutAction } from '../../../state/actions/creators/auth.actioncreator';

class LogoutPage extends PureComponent {
  componentDidMount() {
    const { logoutAction, history } = this.props;
    logoutAction();
    history.replace('/login');
  }

  render() {
    return <div />;
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    logoutAction,
  }, dispatch);
}
export default connect(null, mapDispatchToProps)(LogoutPage);
